import React from 'react';
import { BrowserRouter as Router, Routes, Route, Outlet, Navigate, useLocation } from 'react-router-dom';
import Header from './components/Header';
import Home from './components/Home';
import Dhara from './components/Dhara';
import Anubhuti from './components/Anubhuti';
import Abhyas from './components/Abhyas';
import Ranjana from './components/Ranjana';
import Contact from './components/Contact';
import PrivacyPolicy from './components/PrivacyPolicy';
import BheriGPT from './components/BheriGPT';
import WikiLayout from './components/wiki/WikiLayout';
import styled from 'styled-components';
import GlobalStyles from './styles/GlobalStyles';

function GatiGPTRedirect() {
  const { search, hash } = useLocation();
  return <Navigate to={`/gatigpt${search}${hash}`} replace />;
}

const AppContainer = styled.div`
  min-height: 100vh;
  background: #FAF6ED;
`;

const ContentWrapper = styled.div`
  padding-top: 80px;
`;

function MainLayout() {
  return (
    <AppContainer>
      <Header />
      <ContentWrapper>
        <Outlet />
      </ContentWrapper>
    </AppContainer>
  );
}

function App() {
  return (
    <Router>
      <GlobalStyles />
      <Routes>
        <Route path="/wiki/*" element={<WikiLayout />} />
        <Route element={<MainLayout />}>
          <Route path="/" element={<Home />} />
          <Route path="/dhara" element={<Dhara />} />
          <Route path="/anubhuti" element={<Anubhuti />} />
          <Route path="/abhyas" element={<Abhyas />} />
          <Route path="/ranjana" element={<Ranjana />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/gatigpt" element={<BheriGPT />} />
          <Route path="/GATI-GPT" element={<GatiGPTRedirect />} />
          <Route path="/gati-gpt" element={<GatiGPTRedirect />} />
          <Route path="/GatiGPT" element={<GatiGPTRedirect />} />
          {/* old BheriGPT routes redirect to new path */}
          <Route path="/BheriGPT" element={<GatiGPTRedirect />} />
          <Route path="/bherigpt" element={<GatiGPTRedirect />} />
          <Route path="/BHeriGPT" element={<GatiGPTRedirect />} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
